import React from 'react';
import { Link } from 'react-router-dom';
import PublicOrganizationService from '../../services/publicOrganizationService';
import './OrganizationCard.css';

const OrganizationCard = ({ organization }) => {
  const handleEmailClick = (email) => {
    window.location.href = `mailto:${email}`;
  };

  const handlePhoneClick = (phone) => {
    // Remove any non-digit characters for the tel: link
    const cleanPhone = phone.replace(/\D/g, '');
    window.location.href = `tel:+${cleanPhone}`;
  };

  const handleAddressClick = (address) => {
    // Get properly formatted address for Google Maps
    const addressForMaps = PublicOrganizationService.getAddressForMaps(address);
    if (addressForMaps) {
      const encodedAddress = encodeURIComponent(addressForMaps);
      window.open(`https://maps.google.com/?q=${encodedAddress}`, '_blank');
    }
  };

  // Check if address exists (either as string or object with data)
  const hasAddress = organization.address && 
    (typeof organization.address === 'string' || 
     (typeof organization.address === 'object' && 
      (organization.address.street || organization.address.city || organization.address.state)));

  return (
    <div className="organization-card">
      <div className="organization-header">
        <div className="organization-icon">
          <i className="fas fa-clinic-medical"></i>
        </div>
        <div className="organization-title">
          <h3 className="organization-name">{organization.displayName}</h3>
        </div>
      </div>

      <div className="organization-content">
        {hasAddress && (
          <div className="contact-item">
            <div className="contact-icon">
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <div className="contact-info">
              <span className="contact-label">Dirección</span>
              <button 
                className="contact-value clickable" 
                onClick={() => handleAddressClick(organization.address)}
                title="Ver en Google Maps"
              >
                {organization.displayAddress}
              </button>
            </div>
          </div>
        )}

        {organization.phoneNumber && (
          <div className="contact-item">
            <div className="contact-icon">
              <i className="fas fa-phone"></i>
            </div>
            <div className="contact-info">
              <span className="contact-label">Teléfono</span>
              <button 
                className="contact-value clickable" 
                onClick={() => handlePhoneClick(organization.phoneNumber)}
                title="Llamar"
              >
                {organization.displayPhone}
              </button>
            </div>
          </div>
        )}

        {organization.email && (
          <div className="contact-item">
            <div className="contact-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <div className="contact-info">
              <span className="contact-label">Email</span>
              <button 
                className="contact-value clickable" 
                onClick={() => handleEmailClick(organization.email)}
                title="Enviar email"
              >
                {organization.displayEmail}
              </button>
            </div>
          </div>
        )}
      </div>

      {organization.displayServices && organization.displayServices.length > 0 && (
        <div className="organization-services">
          <h4 className="services-title">Servicios Disponibles</h4>
          <div className="services-list">
            {organization.displayServices.map((service, index) => (
              <span key={index} className="service-badge">
                {service}
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="organization-actions">
        <Link 
          to={`/directory/${organization.id}`}
          className="btn btn-primary view-details-btn"
        >
          <i className="fas fa-eye"></i>
          Ver Detalles
        </Link>
        
        <div className="action-row">
          <button 
            className="btn btn-outline contact-btn"
            onClick={() => handleEmailClick(organization.email)}
            disabled={!organization.email}
          >
            <i className="fas fa-envelope"></i>
            Contactar
          </button>
          
          {hasAddress && (
            <button 
              className="btn btn-secondary location-btn"
              onClick={() => handleAddressClick(organization.address)}
            >
              <i className="fas fa-map-marker-alt"></i>
              Ubicación
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrganizationCard;